import { render, staticRenderFns } from "./BaseQuestionResponse.vue?vue&type=template&id=d93e4a8c&scoped=true&"
import script from "./BaseQuestionResponse.vue?vue&type=script&lang=js&"
export * from "./BaseQuestionResponse.vue?vue&type=script&lang=js&"
import style0 from "./BaseQuestionResponse.vue?vue&type=style&index=0&id=d93e4a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93e4a8c",
  null
  
)

export default component.exports